const getDrawerArea = (state: GlobalState) => state.drawerArea;
export const getDrawerState = (state: GlobalState) => getDrawerArea(state).config;
export const isDrawerOpen = (state: GlobalState) => getDrawerState(state).isOpen;
